var map = {
	"./code-btn.png": "IHtd",
	"./code1.png": "TR0j",
	"./code2.png": "hZ59",
	"./code3.png": "aeqB",
	"./code4.png": "gazY",
	"./code5.png": "vmh2",
	"./code6.png": "Cl5y"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "l1rT";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2 ^\.\/code.*\.png$
// module id = l1rT
// module chunks = 1